import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { BackButton, CopyIcon, EditIcon } from "../../assets/Icons";
import DirectoryIcon from "../../assets/images/root-directory.png";
import DirectoryAppList from "../../components/Tables/DirectoryAppList";
import DirectoryChannelList from "../../components/Tables/DirectoryChannelList";
import AddDirectory from "../../Modals/AddDirectory";
import { handleCopy } from "../../utils";
import { SSO_URL } from "../../env";
import apiClient from "../../apiClient";
import { GET_DIRECTORY_DETAILS, UPDATE_DIRECTORY } from "../../apiClient/apiEndpoints";

const DirectoryInfo = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [tabActiveKey, setTabActiveKey] = useState("application");
  const [openModal, setOpenModal] = useState(false);
  const [copyText, setCopyText] = useState("Copy");

  const [details, setDirectoryDetails] = useState({
    name: "",
    type: "",
    channelId: "",
    token: "",
    channelName: "",
  });

  const [editDetails, setEditDetails] = useState({
    name: "",
    type: "",
    channelId: "",
    token: "",
    channelName: "",
  });

  const fetchDirectoryInfo = async () => {
    try {
      const response = await apiClient.get(`${SSO_URL}${GET_DIRECTORY_DETAILS}/${id}`);
      const obj = {
        name: response?.name,
        type: response.directoryType,
        channelId: response?.defaultChannel?.uuid,
        channelName: response?.defaultChannel?.name,
        token: response.token,
      };
      setDirectoryDetails(obj);
      setEditDetails(obj);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditDetails(details);
  };

  const handleUpdateDetails = async () => {
    try {
      let bodyData = {
        name: editDetails.name,
        type: editDetails.type,
      };
      await apiClient.post(`${SSO_URL}${UPDATE_DIRECTORY}/${id}`, bodyData);
      fetchDirectoryInfo();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseModal();
    }
  };

  useEffect(() => {
    fetchDirectoryInfo();
  }, []);

  const tabItems = [
    { key: "application", label: "Applications", content: <DirectoryAppList directoryDetails={details} /> },
    { key: "channels", label: "Channels", content: <DirectoryChannelList type={'directory'} /> },
    // { key: "roles", label: "Roles", content: <DirectoryChannelList /> },
    // { key: "groups", label: "Groups", content: <DirectoryChannelList /> },
    // { key: "resources", label: "Resources", content: <DirectoryChannelList /> },
  ];

  return (
    <>
      <div className="container-fluid m-0 pt-2">
        <div className="col-12">
          <button className="backbtn cursor-pointer mt-2" onClick={() => navigate(-1)} title="Back">
            <BackButton />
            Back
          </button>
        </div>

        <div className="col-12">
          <div className="application-main mt-3">
            <span className="application-logo p-3">
              <img src={DirectoryIcon} alt="Directory Icon" />
            </span>
            <div className="details-here">
              <span className="name-des">
                <div className="d-flex gap-1 mb-1 align-items-center justify-content-start">
                  <h6 className="m-0">{details.name}</h6>
                  <span className="actionbtns ms-1">
                    <button onClick={() => setOpenModal(true)}>
                      <EditIcon />
                    </button>
                  </span>
                </div>
              </span>

              <div className="tag-list mb-0">
                <p className="mb-0">Type: {details.type}</p>
                <p className="mb-0">Default Channel: {details.channelName}</p>
              </div>

              <div className="tag-list mt-2">
                <p>
                  Token: {details.token}
                  <Tooltip title={copyText}>
                    {" "}
                    <span onClick={handleCopy(details.token, setCopyText)}>
                      {" "}
                      <CopyIcon />{" "}
                    </span>{" "}
                  </Tooltip>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <Tab.Container activeKey={tabActiveKey} onSelect={setTabActiveKey}>
            <div className="row mt-3">
              <div className="tabanddown">
                <Nav variant="pills" className="module-tab">
                  {tabItems.map((tab) => (
                    <Nav.Item key={tab.key}>
                      <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>
            </div>

            <Tab.Content className="mt-01 mb-4">
              {tabItems.map((tab) => (
                <Tab.Pane key={tab.key} eventKey={tab.key}>
                  {tab.content}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>

      <AddDirectory
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        editMode={openModal}
        details={editDetails}
        setDetails={setEditDetails}
        saveNewDirectory={handleUpdateDetails}
      />
    </>
  );
};

export default DirectoryInfo;
